import buttons from './buttons'
import fields from './fields'
import viewTree from './viewTree'

export default {
  buttons,
  fields,
  viewTree,
}
